import React, { useState, useEffect } from 'react';
import { Phone, X } from 'lucide-react';
import { useSiteSettings } from '../context/SiteSettingsContext';

const ClickToCall = () => {
  const { settings } = useSiteSettings();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Only show on mobile
  if (!isMobile) return null;

  const phoneNumber = settings?.phone || '1-800-985-2117';
  const cleanPhone = phoneNumber.replace(/[^0-9+]/g, '');

  return (
    <>
      {/* Expanded Call Panel */}
      {isExpanded && (
        <div className="fixed bottom-20 left-4 right-4 z-50 bg-white rounded-2xl shadow-2xl p-4 animate-slide-up">
          <button 
            onClick={() => setIsExpanded(false)}
            className="absolute top-3 right-3 w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center"
          >
            <X size={16} />
          </button>
          
          <div className="text-center mb-4">
            <h3 className="font-bold text-gray-800 text-lg">Call Big Chief Motors</h3>
            <p className="text-gray-600 text-sm">We're here to help!</p>
          </div>

          <a
            href={`tel:${cleanPhone}`}
            className="block w-full bg-green-600 hover:bg-green-700 text-white text-center py-4 rounded-xl font-semibold text-lg transition-colors"
          >
            <Phone size={20} className="inline mr-2" />
            {phoneNumber}
          </a>

          <p className="text-center text-gray-500 text-xs mt-3">
            Mon-Fri: 9AM-7PM | Sat: 10AM-5PM
          </p>
        </div>
      )}

      {/* Floating Call Button */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="fixed bottom-6 left-6 z-50 w-14 h-14 bg-green-600 hover:bg-green-700 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
        data-testid="click-to-call"
        aria-label="Call us"
      >
        <Phone size={24} className="text-white" />
        
        {/* Pulse animation */}
        <span className="absolute w-full h-full rounded-full bg-green-600 animate-ping opacity-30"></span>
      </button>

      <style jsx>{`
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-slide-up { animation: slide-up 0.3s ease-out; }
      `}</style>
    </>
  );
};

export default ClickToCall;
